import * as Alert from '@/components/ui/alert'
import type { Component, JSX } from 'solid-js'

type QuickAlertProps = {
  title: string
  icon: JSX.Element
  desc?: JSX.Element
}

export const QuickAlert: Component<QuickAlertProps & Alert.RootProps> = (props) => (
  <Alert.Root {...props}>
    <Alert.Indicator
      asChild={(iconProps: () => JSX.IntrinsicAttributes) => {
        const Icon = () => props.icon
        return Icon ? <Icon {...iconProps()} /> : null
      }}
    />
    <Alert.Content>
      <Alert.Title>{props.title}</Alert.Title>
      {props.desc && <Alert.Description>{props.desc}</Alert.Description>}
    </Alert.Content>
  </Alert.Root>
)
